import { Colors } from "../consts/Colors.js";
import AbstractScene from "./AbstractScene.js";
import ButtonRounded from "../prefabs/ButtonRounded.js";

export default class Infographie extends AbstractScene {
  constructor() {
    super({
      key: "Infographie",
    });
  }
  init(data) {
    this._init(data);
  }

  preload() {
    this._preload();
  }

  update() {
    super.update();
  }

  create() {
    this.cameras.main.setBackgroundColor(Colors.Elmt.PaleWhite);

    this.iframe
    this.iframe = document.createElement('iframe');
    this.iframe.src = './assets/iframe/index.html';
    this.UIdom = this.add.dom(this.width / 2, this.height / 2, this.iframe);

    this.style = this.UIdom.node.style;
    this.style.width = 1920 + 'px';
    this.style.height = 1080 + 'px';
    this.style.border = 'none';
    this.style.overflow = "hidden";
    this.UIdom.updateSize();


    window.addEventListener("message", (event) => {
      // Tu peux filtrer ici avec event.origin si besoin
      console.log("Message reçu de l'iframe:", event.data);
      if (event.data.action === "goToMenu") {
        this.scene.restart();
        if (this.game.data.activeIndex < 2) {
          this.game.data.activeIndex = 2;
        }
        this.game.data.validatedIndex = this.game.data.activeIndex;

        this.scene.start("Menu");
      }
    });

  }
}


